import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { TrendingDown, RotateCcw, PiggyBank } from "lucide-react";

const ServicesSection: React.FC = () => {
  return (
    <section className="py-8 md:py-16 bg-accent/30 px-4 md:px-6">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-6 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            Serviços que oferecemos
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto">
            Soluções completas para otimizar sua gestão tributária
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
          <ServiceCard 
            icon={<TrendingDown className="h-6 w-6 md:h-8 md:w-8 text-blue-500" />}
            title="Redução de impostos"
            description="Identificamos oportunidades para reduzir seus impostos em até 65%, resultando em um impacto financeiro significativo e positivo para o seu negócio."
          />
          
          <ServiceCard 
            icon={<RotateCcw className="h-6 w-6 md:h-8 md:w-8 text-blue-500" />}
            title="Restituição corrigida"
            description="Recupere a restituição dos valores pagos erroneamente nos últimos 60 meses, garantindo que seu dinheiro volte para você de forma corrigida."
          />
          
          <ServiceCard 
            icon={<PiggyBank className="h-6 w-6 md:h-8 md:w-8 text-blue-500" />}
            title="Gestão financeira"
            description="Identificamos oportunidades para reduzir seus impostos em até 65%, ajudando você a economizar dinheiro e investir no crescimento do seu negócio."
          />
        </div>
      </div>
    </section>
  );
};

interface ServiceCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ icon, title, description }) => {
  return (
    <Card className="transition-all duration-300 hover:shadow-md h-full border-none shadow-sm">
      <CardContent className="p-3 md:p-6">
        <div className="flex flex-col items-center text-center h-full">
          <div className="mb-3 md:mb-4 p-2 md:p-3 bg-blue-50 rounded-full shadow-sm">
            {icon}
          </div>
          <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-2 md:mb-3">{title}</h3>
          <p className="text-sm md:text-base text-gray-600">{description}</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default ServicesSection;
